// src/admin/components/Lightbox.tsx
import { useEffect } from 'react';
import styles from './Lightbox.module.css';
export default function Lightbox({ url, onClose }: { url: string | null; onClose: () => void }) {
  useEffect(() => {
    if (!url) return;
    const h = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [url, onClose]);
  if (!url) return null;
  return (
    <div className={styles.back} onClick={onClose}>
      <img src={url} alt="" className={styles.img} onClick={e => e.stopPropagation()} />
    </div>
  );
}
